/**
 * Guide engine v3 - DOM probes (#1024, epic #1020).
 *
 * The runtime is page-agnostic (R5-folded): it never navigates and holds no URL
 * field. It only ASKS the DOM whether a step's elements are present yet and what
 * a watched field's value is. These three probes are the entire DOM surface the
 * headless runtime touches; the overlay UI (#1025) owns rendering.
 */

/** True when an element matching `selector` is in the document. */
export const isPresent = (selector) =>
  typeof document !== 'undefined' && document.querySelector(selector) != null;

/** True when every selector in the list is present (empty list = vacuously true). */
export const allPresent = (selectors) => selectors.every(isPresent);

/**
 * Read a watched element's value for a `value` advance (R4). Form controls expose
 * `.value`; anything else falls back to its text content. Absent element = undefined.
 * @param {string} selector
 * @returns {string|undefined}
 */
export const readValue = (selector) => {
  if (typeof document === 'undefined') return undefined;
  const el = document.querySelector(selector);
  if (!el) return undefined;
  return 'value' in el ? el.value : el.textContent;
};
